/* Dúo travieso: one decorative entrance on an explicit standard → Halloween click. */
(function () {
  'use strict';
  var duration = 2600;
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  var current = null;

  function cancel() {
    if (!current) return;
    var state = current;
    current = null;
    cancelAnimationFrame(state.frame);
    state.animations.forEach(function (animation) { animation.cancel(); });
    state.layer.remove();
  }

  function finish() {
    if (!current) return;
    current.apply();
    cancel();
  }

  function run(commit) {
    cancel();
    if (reduced.matches || document.hidden || (window.Shopify && window.Shopify.designMode) ||
        !window.Element.prototype.animate || !document.body) {
      commit();
      return;
    }
    var layer = document.createElement('div');
    layer.className = 'piex-mode-transition';
    layer.setAttribute('aria-hidden', 'true');
    layer.setAttribute('inert', '');
    var applied = false;
    var state = current = {
      layer: layer, animations: [], frame: 0,
      apply: function () { if (!applied) { applied = true; commit(); } }
    };
    function animate(element, frames, options) {
      var animation = element.animate(frames, options);
      state.animations.push(animation);
      return animation;
    }
    try {
      var width = document.documentElement.clientWidth;
      var height = window.innerHeight;
      var mobile = width < 600;
      layer.innerHTML = '<div class="px-curtain"></div>';
      document.body.appendChild(layer);
      if (window.getComputedStyle(layer).position !== 'fixed') {
        finish();
        return;
      }
      // The curtain fully covers the previous theme before applying the new one.
      // The second half uncovers the real page: no cloned controls or content.
      var curtain = animate(layer.firstElementChild, [
        { transform: 'translateX(-101%)', offset: 0 },
        { transform: 'translateX(0)', offset: .28 },
        { transform: 'translateX(0)', offset: .36 },
        { transform: 'translateX(101%)', offset: .66 },
        { transform: 'translateX(101%)', offset: 1 }
      ], { duration: duration, fill: 'forwards', easing: 'ease-in-out' });
      // Read the rendered animation timeline, never a wall-clock timeout. A busy
      // or occluded browser may start painting later than it runs JavaScript.
      function followCurtain() {
        if (current !== state) return;
        if (curtain.currentTime >= duration * .32) state.apply();
        state.frame = requestAnimationFrame(followCurtain);
      }
      state.frame = requestAnimationFrame(followCurtain);
      curtain.finished.then(function () { if (current === state) finish(); }, function () { /* Cancelled entrance. */ });

      var skeleton = '<div class="px-skeleton"><div class="px-skull"></div><div class="px-spine"></div>' +
        '<div class="px-rib a"></div><div class="px-rib b"></div><div class="px-rib c"></div><div class="px-hip"></div>' +
        ['arm-left', 'arm-right', 'leg-left', 'leg-right'].map(function (name) {
          return '<div class="px-limb px-' + name + '"><div class="px-limb"></div></div>';
        }).join('') + '</div>';
      [['skeleton', .73, 0, .95], ['ghost', .43, .13, .85]].forEach(function (spec, index) {
        var hanger = document.createElement('div');
        hanger.className = 'px-hanger';
        hanger.style.left = (width * spec[1] - 46) + 'px';
        hanger.innerHTML = '<div class="px-string"></div>' + (spec[0] === 'skeleton' ? skeleton : '<div class="px-ghost"></div>');
        layer.appendChild(hanger);
        var scale = spec[3] * (mobile ? .8 : 1.15);
        var drop = Math.min(height * .1, 65);
        var tilt = index ? -12 : 12;
        function pose(y, angle) { return 'translateY(' + y + 'px) rotate(' + angle + 'deg) scale(' + scale + ')'; }
        animate(hanger, [
          { transform: pose(-420, 0), offset: 0 },
          { transform: pose(drop + 18, -tilt * .4), offset: .25 },
          { transform: pose(drop - 9, tilt * .4), offset: .34 },
          { transform: pose(drop, -tilt), offset: .48 },
          { transform: pose(drop, tilt * .5), offset: .64 },
          { transform: pose(drop - 5, -tilt * .2), offset: .75 },
          { transform: pose(-420, 0), offset: 1 }
        ], { duration: duration * (.91 - spec[2]), delay: duration * spec[2], fill: 'forwards', easing: 'ease-in-out' });
        hanger.querySelectorAll('.px-arm-left,.px-arm-right,.px-leg-left,.px-leg-right').forEach(function (limb, j) {
          var base = [28, -28, 10, -10][j];
          animate(limb, [base, base + (j % 2 ? -24 : 24), base - (j % 2 ? -12 : 12), base].map(function (angle) {
            return { transform: 'rotate(' + angle + 'deg)' };
          }), { duration: duration * .58, delay: duration * (spec[2] + .2), fill: 'forwards', easing: 'ease-in-out' });
        });
      });

      var count = mobile ? 18 : 28;
      for (var i = 0; i < count; i++) {
        var bat = document.createElement('span');
        bat.className = 'px-bat';
        bat.innerHTML = '<span class="px-wing"></span><span class="px-wing px-wing-r"></span><span class="px-bat-body"></span>';
        var size = (mobile ? 23 : 32) + ((i * 19) % 34);
        bat.style.width = size + 'px';
        bat.style.height = size * .52 + 'px';
        layer.appendChild(bat);
        var y = 40 + ((i * .61803398875) % 1) * Math.max(100, height - 130);
        var delay = (i % 6) * duration * .025 + (i >= count * .6 ? duration * .2 : 0);
        function frame(x, dy, opacity, rotation) {
          return { transform: 'translate(' + x + 'px,' + (y + dy) + 'px) rotate(' + rotation + 'deg)', opacity: opacity };
        }
        animate(bat, [frame(-100, 20, 0, -10), Object.assign(frame(width * .22, -24, .9, 9), { offset: .24 }),
          Object.assign(frame(width * .66, 24, 1, -7), { offset: .66 }), frame(width + 120, -25, 0, 12)],
        { duration: duration * .65, delay: delay, fill: 'forwards', easing: 'linear' });
        bat.querySelectorAll('.px-wing').forEach(function (wing, j) {
          var sign = j ? -1 : 1;
          var flap = 145 + (i % 3) * 30;
          animate(wing, [ { transform: 'scale(' + sign + ',1)' }, { transform: 'scale(' + sign * .5 + ',.62)' },
            { transform: 'scale(' + sign + ',1)' } ], { duration: flap, iterations: Math.ceil(duration * .65 / flap), delay: delay });
        });
      }
    } catch (error) {
      // A decorative effect must never prevent changing the store.
      state.apply();
      cancel();
    }
  }

  document.addEventListener('visibilitychange', function () { if (document.hidden) finish(); });
  document.addEventListener('shopify:section:load', finish);
  window.addEventListener('pagehide', finish);
  window.addEventListener('resize', finish);
  reduced.addEventListener('change', function () { if (reduced.matches) finish(); });
  window.PiexModeTransition = { run: run, cancel: cancel };
}());
